module.exports = __webpack_public_path__ + "img/NBOF final logo.4c058ca8.jpg";